import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 10"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i-372968532__a" }, [
        _createElementVNode("rect", {
          width: "10",
          height: "10",
          rx: "0"
        })
      ])
    ], -1),
    _createElementVNode("g", { "clip-path": "url(#i-372968532__a)" }, [
      _createElementVNode("path", {
        fill: "#743A3A",
        d: "M7.713 2.287A3.81 3.81 0 0 0 5 1.163a3.81 3.81 0 0 0-2.713 1.124A3.81 3.81 0 0 0 1.163 5a3.81 3.81 0 0 0 1.124 2.713A3.81 3.81 0 0 0 5 8.837a3.81 3.81 0 0 0 2.713-1.124A3.81 3.81 0 0 0 8.837 5a3.81 3.81 0 0 0-1.124-2.713Zm-.666 2.367-.768.75.181 1.056a.356.356 0 0 1-.143.351.357.357 0 0 1-.378.027l-.95-.499-.95.5a.359.359 0 0 1-.521-.378L3.7 5.401l-.768-.749a.355.355 0 0 1-.091-.368.356.356 0 0 1 .29-.244l1.061-.154.475-.962a.355.355 0 0 1 .322-.2c.138 0 .261.077.322.2l.475.962 1.061.154c.136.02.248.113.29.245a.354.354 0 0 1-.09.368Z"
      })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "integrals"}) } }